<template>
  <div />
</template>

<script>
  import BaseStep from './BaseStep.vue';

  export default {
    extends: BaseStep,
    methods: {
      init() {
        if (this.stepState.url) {
          document.location = this.stepState.url;
        }
      }
    }
  }
</script>
